import React from 'react';
import { Box, TextField, Button, Stack } from '@mui/material';
import { CrmFilters, DEFAULT_CRM_FILTERS } from '../hooks/useCrmTable';

interface CrmSearchFiltersProps {
  filters: CrmFilters;
  onSearch: (newFilters: CrmFilters) => void;
  fixedCustomerType?: 'individual' | 'corporate' | '';
}

const CrmSearchFilters: React.FC<CrmSearchFiltersProps> = ({ filters, onSearch, fixedCustomerType }) => {
  const [localFilters, setLocalFilters] = React.useState<CrmFilters>(filters);

  // fixedCustomerType が変更されたらローカル状態も同期する
  React.useEffect(() => {
    if (fixedCustomerType !== undefined) {
      setLocalFilters(prev => ({ ...prev, customer_type: fixedCustomerType }));
    }
  }, [fixedCustomerType]);

  const handleChange = (field: keyof CrmFilters, value: any) => {
    setLocalFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApply = () => {
    onSearch(localFilters);
  };

  const handleReset = () => {
    const resetFilters = { ...DEFAULT_CRM_FILTERS };
    if (fixedCustomerType) {
      resetFilters.customer_type = fixedCustomerType;
    }
    setLocalFilters(resetFilters);
    onSearch(resetFilters);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Stack spacing={2}>
        <TextField
          label="キーワード検索"
          variant="outlined"
          size="small"
          fullWidth
          value={localFilters.search_word}
          onChange={(e) => handleChange('search_word', e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleApply();
            }
          }}
          placeholder="名前 or 会社名"
        />
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={handleReset} variant="outlined" size="small">リセット</Button>
          <Button onClick={handleApply} variant="contained" size="small" color="primary">検索</Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CrmSearchFilters;
